import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default {
    namespaced: true,
    state: {
        cart: {},
        total: {},
        sources: {},
        spareCount: 0,
        priceMatrix: {},
        cheapest: {},
    },
    mutations: {
        refreshCartSources: function(state){
            state.sources = {};
            for (let i in state.cart) {
                if (state.cart[i].sources) {
                    for (let source in state.cart[i].sources) {
                        Vue.set(state.sources, source, source);
                    }
                }
            }
        },
        putCartItem: function(state, item) {
            if ( ! state.cart[item.id]) {
                Vue.set(state.cart, item.id,{
                    qty: 0,
                    item: item,
                    sources: item.sources,
                    identical: item.identical,
                });
            }
        },
        changeCartQty: function(state, payload) {
            let cart = Object.assign({}, state.cart);
            if (cart[payload.id]) {

                cart[payload.id].qty += payload.qty;

                if (cart[payload.id].qty === 0) {
                    delete cart[payload.id];
                }
            }
            state.cart = cart;
        },
        emptyCart: function(state) {
            state.cart = {};
            state.total = {};
            state.sources = {};
            state.spareCount = 0;
            state.priceMatrix = {};
            state.cheapest = {};
        },
        createMatrix: function(state){

            let matrix = {};
            let total = {};
            let cheapest = {};

            for (let id in state.cart) {
                matrix[id] = {};
            }

            for (let source in state.sources) {
                total[source] = 0.00;
            }

            for (let id in matrix) {
                let identical = state.cart[id].identical;
                for (let idx in identical) {
                    let item = identical[idx];
                    if ( ! matrix[id][item.source]) {
                        matrix[id][item.source] = {
                            price: parseFloat(item.price),
                            link: item.link,
                        };
                        total[item.source] += parseFloat(item.price) * state.cart[id].qty;
                    }
                }
            }

            for (let id in matrix) {
                let price = 9999999;
                let src = "";
                for (let source in matrix[id]) {
                    if (matrix[id][source]['price'] < price) {
                        price = matrix[id][source]['price'];
                        src = source;
                    }
                }
                cheapest[id] = src;
            }

            state.cheapest = cheapest;
            state.total = total;
            state.priceMatrix = matrix;
        },
        updateCount: function(state){
            state.spareCount = 0;
            for (let id in state.cart) {
                state.spareCount += state.cart[id].qty;
            }
        },
        removeCartItem: function(state, id){
            let cart = Object.assign({}, state.cart);
            delete cart[id];
            state.cart = cart;
        },
        saveToStorage: function(state){
            localStorage.setItem('cart', JSON.stringify(state));
        },
        loadFromStorage: function(state){
            if (localStorage.getItem('cart')) {
                try {

                    let json = JSON.parse(localStorage.getItem('cart'));
                    state.cart = json.cart;
                    state.total = json.total;
                    state.sources = json.sources;
                    state.spareCount = json.spareCount;
                    state.priceMatrix = json.priceMatrix;

                } catch(e) {
                    localStorage.removeItem('cart');
                }
            }
        },
    },
    actions: {
        fromStorage: function(context){
            context.commit('loadFromStorage');
        },
        removeCartItem: function(context, id){
            context.commit('removeCartItem', id);
            context.commit('refreshCartSources');
            context.commit('createMatrix');
            context.commit('updateCount');
            context.commit('saveToStorage');
        },
        putCartItem: function(context, item){
            context.commit('putCartItem', item);
            context.commit('refreshCartSources');
            context.commit('createMatrix');
            context.commit('updateCount');
            context.commit('saveToStorage');
        },
        incCartItem: function(context, id){
            context.commit('changeCartQty', {
                id: id,
                qty: 1
            });
            context.commit('refreshCartSources');
            context.commit('createMatrix');
            context.commit('updateCount');
            context.commit('saveToStorage');
        },
        decCartItem: function(context, id){
            context.commit('changeCartQty', {
                id: id,
                qty: -1
            });
            context.commit('updateCount');
            context.commit('refreshCartSources');
            context.commit('createMatrix');
            context.commit('saveToStorage');
        },
        emptyCart: function(context) {
            context.commit('emptyCart');
            context.commit('saveToStorage');
        },
    },
    getters: {
        getAllData: function(state) {
            return state;
        },
        getCart: function(state){
            return state.cart;
        },
        getSources: function(state){
            return state.sources
        },
        getCount: function(state){
            return state.spareCount;
        },
        getMatrix: function(state) {
            return state.priceMatrix;
        },
        getTotal: function(state){
            return state.total;
        },
        getCheapestMap: function(state){
            return state.cheapest;
        },
    },

}